export const DAYS = [3, 4, 5, 6, 7];